module.exports = __webpack_public_path__ + "9bd43a58e94ae17fbf74df8949a1797f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/imgs/logo/Spotin_TM_Logo_True-White_Small_RGB.png
// module id = 188
// module chunks = 0